module.exports = __webpack_public_path__ + "assets/dc922d8ff92c778c474e05609ae48334.png";